import RestApiModel from "@/api/Model/RestApiModel";
import PrintIssueSystem from '@/api/Facility/PrintIssueSystem';
import PrintIssueMethod from '@/api/Facility/PrintIssueMethod';
import api from '../index';

class Sections extends RestApiModel {
  static printIssueSystem = PrintIssueSystem;
  static printIssueMethod = PrintIssueMethod;

  static list(facilityId) {
    return super.list({
      endpoint: `/facilities/${facilityId}/sections`
    })
  }

  static getResourceEndpoint(facilityId) {
    return `/facility-sections`;
  }

  /**
   * Get products for a section
   * @param sectionId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static products(sectionId) {
    return super.list({
      endpoint: this.getResourceIdEndpoint(sectionId, 'products')
    });
  }
  /**
   * Get products for a section
   * @param sectionId
   * @param productId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static getProduct(sectionId, productId) {
    return api.get(this.getResourceIdEndpoint(sectionId, 'products/' + productId));
  }
  /**
   * Get products for a section
   * @param params
   * @param sectionId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static createProduct(params, sectionId) {
    return api.post(this.getResourceIdEndpoint(sectionId, 'products'), params);
  }

  /**
   * Get products for a section
   * @param params
   * @param sectionId
   * @param productId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static updateProduct(params, sectionId, productId) {
    return api.patch(this.getResourceIdEndpoint(sectionId, 'products/' + productId), params);
  }

  /**
   * Get products for a section
   * @param sectionId
   * @param productId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static deleteProduct(sectionId, productId) {
    return api.delete(this.getResourceIdEndpoint(sectionId, 'products/' + productId));
  }
  /**
   * Get products for a section
   * @param sectionId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static riskCodes(sectionId) {
    return super.list({
      endpoint: this.getResourceIdEndpoint(sectionId, 'risk-codes')
    });
  }
  /**
   * Get products for a section
   * @param sectionId
   * @param riskCodeId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static getRiskCode(sectionId, riskCodeId) {
    return api.get(this.getResourceIdEndpoint(sectionId, 'risk-codes/' + riskCodeId));
  }
  /**
   * Get products for a section
   * @param params
   * @param sectionId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static createRiskCode(params, sectionId) {
    return api.post(this.getResourceIdEndpoint(sectionId, 'risk-codes'), params);
  }

  /**
   * Get products for a section
   * @param params
   * @param sectionId
   * @param riskCodeId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static updateRiskCode(params, sectionId, riskCodeId) {
    return api.patch(this.getResourceIdEndpoint(sectionId, 'risk-codes/' + riskCodeId), params);
  }

  /**
   * Get products for a section
   * @param sectionId
   * @param riskCodeId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static deleteRiskCode(sectionId, riskCodeId) {
    return api.delete(this.getResourceIdEndpoint(sectionId, 'risk-codes/' + riskCodeId));
  }

  /**
   * Get facility ancestors for a section
   * @param sectionId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static ancestors(sectionId) {
    return super.list({
      endpoint: this.getResourceIdEndpoint(sectionId, 'ancestors')
    });
  }
  /**
   * Get products for a section
   * @param sectionId
   * @param ancestorId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static getAncestor(sectionId, ancestorId) {
    return api.get(this.getResourceIdEndpoint(sectionId, 'ancestors/' + ancestorId));
  }
  /**
   * Get products for a section
   * @param params
   * @param sectionId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static createAncestor(params, sectionId) {
    return api.post(this.getResourceIdEndpoint(sectionId, 'ancestors'), params);
  }

  /**
   * Get products for a section
   * @param params
   * @param sectionId
   * @param ancestorId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static updateAncestor(params, sectionId, ancestorId) {
    return api.patch(this.getResourceIdEndpoint(sectionId, 'ancestors/' + ancestorId), params);
  }

  /**
   * Get products for a section
   * @param sectionId
   * @param ancestorId
   * @returns {Promise<AxiosResponse<any>>}
   */
  static deleteAncestor(sectionId, ancestorId) {
    return api.delete(this.getResourceIdEndpoint(sectionId, 'ancestors/' + ancestorId));
  }
}

export default Sections;
